import { render, staticRenderFns } from "./HelpDeskRequestView.vue?vue&type=template&id=04d06f34&"
import script from "./HelpDeskRequestView.vue?vue&type=script&lang=js&"
export * from "./HelpDeskRequestView.vue?vue&type=script&lang=js&"
import style0 from "./HelpDeskRequestView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports